import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CFieldStatusComponent } from './c-field-status.component';



@NgModule({

  declarations: [CFieldStatusComponent],
  imports: [
    CommonModule,
  ],
  exports: [CFieldStatusComponent]
})
export class CFieldStatusModule { }
